import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-sms",
  "use": "app-channel-sms-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-sms\"><path d=\"M18.862 16.304a3.303 3.303 0 001.915-2.819c0-1.238-.66-2.818-2.186-2.818m-5.952 5.637a3.303 3.303 0 001.916-2.819c0-1.238-.66-2.818-2.186-2.818M27.555 24H15.11l-7.112 5.334V24H4.444a1.778 1.778 0 01-1.778-1.777V4.445c0-.982.796-1.778 1.778-1.778h23.11c.983 0 1.779.796 1.779 1.778v17.777c0 .982-.796 1.778-1.778 1.778zm-8-12.444a.889.889 0 10-1.778 0 .889.889 0 001.778 0zm-6.222 0a.889.889 0 10-1.778 0 .889.889 0 001.778 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-sms.svg
// module id = 8WsU
// module chunks = 38 43